<template>
  <main class="home">
    <div class="title">
      北海道教育大学函館校 青木研究室 Webアプリケーション
      <h1>初等整数論</h1>
    </div>
    <section>
      <h2> メニュー </h2>
      <ul>
	<li> <router-link to="/decimal"> 有理数の無限小数展開 </router-link> </li>
	<li> <router-link to="/order"> mを法とした位数 </router-link> </li>
	<li> <router-link to="/calc"> ガウス整数計算機 </router-link> </li>
	<li> <router-link to="/div"> ガウス整数の除法 </router-link> </li>
	<li> <router-link to="/euclid"> ガウス整数のユークリッド互除法 </router-link> </li>
	<li> <router-link to="/mill"> 「ザギエの風車」によるフェルマーの2平方和定理の証明 </router-link> </li>
      </ul>
    </section>
    <section>
      <p> 開発中のため、計算結果等には誤りがあることもあります。誤りを発見した場合は作者(青木)まで連絡してください。</p>
      <p> This application uses <a href="https://vuejs.org/">vue.js</a>.</p>
    </section>
  </main>
</template>

<script lang="ts" setup>
</script>
